export function shouldAllowQuantityKey(
  key: string,
  currentValue: string,
  selectionStart: number | null,
  selectionEnd: number | null,
  hasModifier: boolean,
): boolean {
  if (hasModifier) return true;
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'Tab' ||
    key === 'Escape' ||
    key === 'Enter' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Home' ||
    key === 'End'
  ) {
    return true;
  }
  if (/^\d$/.test(key)) return true;
  if (key !== '.' && key !== ',') return false;

  const start = selectionStart ?? currentValue.length;
  const end = selectionEnd ?? currentValue.length;
  const hasExistingSeparatorOutsideSelection =
    currentValue.slice(0, start).includes('.') || currentValue.slice(end).includes('.');
  return !hasExistingSeparatorOutsideSelection;
}
